import { useState }  from "react";
import ApiMakes from '../../api/makes';
import { useDispatch } from "react-redux";
import { makes as actionsMakes, log as actionsLog } from '../../store/actions';
import AddNewItemForm from '../general/AddNewItemForm';

const { getMakes } = actionsMakes;
const { addToLog } = actionsLog;

const MakesNew = () => {

    let dispatch = useDispatch();

    const addNewMake = e => {
        e.preventDefault();
        if (name.trim() !== '') {
            ApiMakes.post(name).then(resp => {
                setName("");
                dispatch(getMakes());
                dispatch(addToLog(resp));
            });
        }
    }

    const updateName = e => {
        const name = e.target.value;
        setName(name);
    };

    const [ name, setName ] = useState("");

    return (
        <AddNewItemForm title="Add new make" value={name} onSubmit={addNewMake} onChange={updateName} />
    );
}

export default MakesNew;